import React from 'react';

const HelpPicture = (_) => {

    return (
		<div>
			<h2 className="text-center dark"> Publik/Privat </h2>
		
			Som publik ägare/uppfödare är dina uppgifter tillgängliga för de som ser en kanin du har relation till.
			Det kan vara en kanin du fött upp, en där du står som nuvarande/föregående ägare eller en kanin någon hittat och försöker återbörda.
			<p/>
			Som privat ägare/uppfödare är dina uppgifter endast tillgängliga för Kaninregistret.
			Vi lämnar aldrig ut dessa till privatpersoner, men förmedlar meddelanden vid behov (exempelvis om någon hittat din kanin).
			Till veterinärer och myndigheter kommer vi dock lämna ut dina uppgifter på begäran, om inte förmedling räcker.
		</div>
	)
}

export default HelpPicture;